var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { isString, compact, uniq, flatten, filter, includes } from "lodash";
import doValidation from "@irati/utils/validation/shared/doValidation";
export var DONT_INCLUDE = "dont_include";
export var FIRSTNAME = "firstName";
export var LASTNAME = "lastName";
export var EMAIL = "email";
export var ROLES = "roles";
export var TEAMS = "teams";
export var EXTERNAL_ID = "external_id";
var i18nKeyFirstName = "admin.components.addPeopleCSV.fieldsMapping.firstName.label";
var i18nKeyLatName = "admin.components.addPeopleCSV.fieldsMapping.lastName.label";
var i18nKeyEmail = "admin.components.addPeopleCSV.fieldsMapping.email.label";
var i18nKeyRole = "admin.components.addPeopleCSV.fieldsMapping.role.label";
var i18nKeyTeam = "admin.components.addPeopleCSV.fieldsMapping.team.label";
var i18nKeyExternalId = "admin.components.addPeopleCSV.fieldsMapping.externalId.label";
var emailIndexInRow = function (row) {
    return Object.values(row).findIndex(function (header) { return header.includes("@"); });
};
var trimValue = function (value) {
    if (!isString(value)) {
        return value;
    }
    return value.trim().length > 0 ? value.trim() : null;
};
export var getUserCSVHeaders = function (row, formatMessage) {
    var emailIndex = emailIndexInRow(row);
    if (emailIndex >= 0) {
        return Object.values(row).map(function (col, i) {
            if (emailIndex === i) {
                return "email";
            }
            return "";
        });
    }
    var i18nFirstName = formatMessage({ id: i18nKeyFirstName })
        .replace(" ", "")
        .toLowerCase();
    var i18nLastName = formatMessage({ id: i18nKeyLatName })
        .replace(" ", "")
        .toLowerCase();
    var i18nEmail = formatMessage({ id: i18nKeyEmail })
        .replace(" ", "")
        .toLowerCase();
    var i18nRole = formatMessage({ id: i18nKeyRole })
        .replace(" ", "")
        .toLowerCase();
    var i18nTeam = formatMessage({ id: i18nKeyTeam })
        .replace(" ", "")
        .toLowerCase();
    var i18nExternalId = formatMessage({ id: i18nKeyExternalId })
        .replace(" ", "")
        .toLowerCase();
    return __spreadArrays(Object.values(row).map(function (column) {
        var label;
        switch (column.replace(" ", "").toLowerCase()) {
            case FIRSTNAME:
            case i18nFirstName:
            case "firstname":
            case "fname":
                label = FIRSTNAME;
                break;
            case LASTNAME:
            case i18nLastName:
            case "lastname":
            case "lname":
                label = LASTNAME;
                break;
            case EMAIL:
            case i18nEmail:
            case "emailaddress":
                label = EMAIL;
                break;
            case ROLES:
            case i18nRole:
                label = ROLES;
                break;
            case TEAMS:
            case i18nTeam:
            case "team":
                label = TEAMS;
                break;
            case EXTERNAL_ID:
            case i18nExternalId:
            case "externalid":
                label = EXTERNAL_ID;
                break;
            default:
                label = "";
                break;
        }
        return label;
    }));
};
export var getUserCSVRows = function (rows) {
    var emailIndex = emailIndexInRow(rows[0]);
    if (emailIndex >= 0) {
        // first row has an email so no headers, return all
        return rows;
    }
    return rows.slice(1);
};
export var csvRowToUser = function (headers, row) {
    var user = {};
    var errors = [];
    headers.forEach(function (header, idx) {
        var _a;
        var label = header;
        var value = row[Object.keys(row)[idx]];
        if (header && header !== DONT_INCLUDE) {
            if ([FIRSTNAME, LASTNAME, EMAIL, TEAMS, EXTERNAL_ID].indexOf(header) > -1) {
                value = trimValue(value);
            }
            if (header !== ROLES && header !== TEAMS && header !== EXTERNAL_ID) {
                var check = doValidation({ label: label, value: value });
                if (!check.isValid) {
                    errors.push(label + " is not valid");
                }
            }
            user = __assign(__assign({}, user), (_a = {}, _a[label] = value, _a));
        }
    });
    return { user: user, errors: errors };
};
export var getUniqueEmails = function (emails) {
    return compact(uniq(flatten(emails)));
};
export var getDuplicateEmails = function (emails) {
    return compact(filter(flatten(emails), function (value, index, iteratee) {
        return includes(iteratee, value, index + 1);
    }));
};
